import React from 'react';

import {Typography} from '@mui/material';

export const UseWithTooltip = () => {
  return (
    <div>
      <Typography variant='body2'>
        Normally storage can be used to hold data for objects in any bucket. The storage class and lifecycle
        determine which storage is chosen for each object's data. Selecting specific buckets
        to use ensures only objects in those buckets will ever have their data stored here.
      </Typography>
    </div>
  );
};

